import { createContext, useContext } from "react";
import type { DropdownContextValue } from "./types";

const DropdownContext = createContext<DropdownContextValue | undefined>(
  undefined,
);

export const DropdownProvider = DropdownContext.Provider;

export const useDropdownContext = (): DropdownContextValue => {
  const context = useContext(DropdownContext);
  if (!context) {
    throw new Error(
      "useDropdownContext must be used within a DropdownProvider",
    );
  }
  return context;
};
